import { Card, CardContent, Grid } from '@material-ui/core'
import { useStyles } from './work-list-comments.styles'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
import moment from 'moment'

export const SppWorkListCommentCard = ({ comment }) => {
  const classes = useStyles()

  return (
    <Card className={classes.commentCard}>
      <CardContent className={classes.commentCardContent}>
        <Grid container>
          <Grid item container style={{ marginBottom: 16 }}>
            <Grid item style={{ marginRight: 12 }}>
              <AsterTypography style={{ color: PRIMARY_COLORS[700] }}>
                {comment?.userFullName || ''}
              </AsterTypography>
            </Grid>
            <Grid item>
              <AsterTypography style={{ color: GRAY_COLORS[400] }}>
                {comment?.createdDate
                  ? moment(comment?.createdDate).format('h:mm D MMMM YYYY')
                  : ''}
              </AsterTypography>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <AsterTypography>{comment?.text || ''}</AsterTypography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
